import base from './base';
import axios from '../http';

const commonApi = {
	login(params) {
		return axios.post(`${base.serverUrl}/auth/login`, params);
	}
};

export default commonApi;